<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Giáo Viên</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-teacher-group"
          :label="'Cho phép ' + roleName + ' thiết lập giáo viên'"
          hide-details
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- giáo viên -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-teacher-list"
          :label="'Cho phép ' + roleName + ' xem danh sách giáo viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-teacher"
          :label="'Cho phép ' + roleName + ' thêm mới giáo viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-teacher-info"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin giáo viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-teacher"
          :label="'Cho phép ' + roleName + ' xóa giáo viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-teacher-status"
          :label="'Cho phép ' + roleName + ' chuyển trạng thái giáo viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- giảng dạy -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-teaching-list"
          :label="'Cho phép ' + roleName + ' xem danh sách giảng dạy'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-teaching"
          :label="'Cho phép ' + roleName + ' thêm phân công giảng dạy'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-teaching"
          :label="'Cho phép ' + roleName + ' cập nhật phân công giảng dạy'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-teaching"
          :label="'Cho phép ' + roleName + ' xóa phân công giảng dạy'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- chủ nhiệm -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-ownClass-list"
          :label="'Cho phép ' + roleName + ' xem danh sách chủ nhiệm'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-ownClass"
          :label="'Cho phép ' + roleName + ' thêm phân công chủ nhiệm'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-ownClass"
          :label="'Cho phép ' + roleName + ' cập nhật phân công chủ nhiệm'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-ownClass"
          :label="'Cho phép ' + roleName + ' xóa phân công chủ nhiệm'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>

<style scoped></style>
